import React from "react";
import { DeviceWidth, useDeviceWidthQuery } from "../MediaQuery";
import { ResponsiveLayout } from "../ResponsiveLayout";
import { SizedBox } from "../SizedBox";
import { StoreButtonsBlock } from "../StoreButtonsBlock";
import { translation } from "../translations";
import { Header4 } from "../typography";
import { SlantedSection } from "./SlantedSection";

export const StoreRatingSection: React.FC = () => {
  const width = useDeviceWidthQuery();
  return (
    <SlantedSection
      justifyContent="left"
      gradient
      offset={155}
      height={229}
      width={1400}
    >
      <ResponsiveLayout justifyContent="center" alignItems="center">
        <SizedBox desktopWidth={100} />

        <div>
          <img
            style={{ height: width === DeviceWidth.desktop ? 64 : 42 }}
            src="/home/rating.png"
          />
          <Header4 color="white" center>
            {translation.ratingInAppStore}
          </Header4>
        </div>

        <SizedBox desktopWidth={80} mobileHeight={8} />

        <StoreButtonsBlock
          forceVerticalLayout={true}
          showStoreButtonsCallToAction={width === DeviceWidth.desktop}
        />
      </ResponsiveLayout>
    </SlantedSection>
  );
};
